// extracted by mini-css-extract-plugin
export default {"inputField":"Input_inputField__DIA7w","header":"Input_header__gqS-2","divider":"Input_divider__rQAMP","headerContainer":"Input_headerContainer__ePTqZ"};